//create a simple modal using react where it has a confirm action button

import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import {
  changePayment
} from "../../../api/caseApi";
const ConfirmCancelPayment = ({ open, onClose, caseDetails }) => {
    const handleConfirmCancelPayment = async (caseEntity) => {
        try{
            await changePayment(caseEntity.id);
            onClose();
            window.location.reload();
        }catch(e){
            onClose();
        }
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Cancel Payment</DialogTitle>
            <DialogContent>
                <p>Are you sure you want to cancel this patient's payment plan?</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleConfirmCancelPayment(caseDetails)} color="error">
                    Confirm
                </Button>
                <Button onClick={onClose}>Exit</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmCancelPayment;